// O'Neill Canada: flash a spend-more promo headline when the shopper gets CLOSER to a
// reward (item added / quantity up) -- but NOT when they move away (item removed /
// quantity down). Direction is read from the progress-bar fill width, which tracks the
// cart subtotal monotonically, so it stays correct even when an add crosses a tier
// (where the "away from" amount jumps up to the next tier).
//
// Covers both banners with one watcher:
//   .ctl-cart-promo__headline  (cart summary / mini-cart) -> .is-cued
//   .ctl-promo__headline       (Complete the Look drawer) -> .is-bumped
(function () {
  if (window.__promoCue) return;
  window.__promoCue = true;

  var targets = [
    { headline: '.ctl-cart-promo__headline', fill: '.ctl-cart-promo__fill', cls: 'is-cued' },
    { headline: '.ctl-promo__headline', fill: '.ctl-promo__fill', cls: 'is-bumped' },
  ];
  var lastText = {};
  var lastFill = {};

  function fillPct(selector) {
    var el = document.querySelector(selector);
    if (!el) return null;
    var w = parseFloat(el.style.width);
    return isNaN(w) ? null : w;
  }

  function cue() {
    for (var i = 0; i < targets.length; i++) {
      var t = targets[i];
      var el = document.querySelector(t.headline);
      if (!el) continue;

      var txt = (el.textContent || '').trim();
      var fill = fillPct(t.fill);
      var prevText = lastText[t.headline];
      var prevFill = lastFill[t.headline];

      if (prevText !== undefined && prevText !== txt && txt !== '') {
        // Animate only when the subtotal went UP (got closer to a reward). If we can't
        // read the fill on either side, fall back to animating on any change.
        var increased =
          fill === null || prevFill === undefined || prevFill === null ? true : fill > prevFill + 0.01;
        if (increased) {
          el.classList.remove(t.cls);
          void el.offsetWidth; // reflow so the animation restarts
          el.classList.add(t.cls);
        }
      }

      lastText[t.headline] = txt;
      if (fill !== null) lastFill[t.headline] = fill;
    }
  }

  function init() {
    cue();
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        cue();
      });
    });
    // childList + characterData covers both re-render styles (node replaced vs text
    // node changed); attributes are not observed, so our own class toggle can't loop.
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
